export const CALENDAR_API_QUERY_EVENT_TYPES = {
  BIRTHDAY: 'BIRTHDAY',
  TASKS: 'TASKS',
  OUTLOOK: 'OUTLOOK',
} as const;

export const CALENDAR_API_QUERY_VIEWS = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
} as const;

export const CALENDAR_API_ITEM_TYPES = {
  BIRTHDAY: 'birthday',
  TASK_DUE: 'task_due',
  TASK_OVERDUE: 'task_overdue',
  TASK_REMINDER: 'task_reminder',
  EXTERNAL_EVENT: 'external_event',
} as const;

export const CALENDAR_API_SOURCES = {
  USERS: 'users',
  CLIENT_TASKS: 'client_tasks',
  OUTLOOK_CALENDAR: 'outlook_calendar',
} as const;

export const CALENDAR_API_ENTITY_TYPES = {
  USER: 'user',
  CLIENT_TASK: 'client_task',
  OUTLOOK_EVENT: 'outlook_event',
} as const;

export const CALENDAR_DEFAULT_QUERY_EVENT_TYPES = [
  CALENDAR_API_QUERY_EVENT_TYPES.BIRTHDAY,
  CALENDAR_API_QUERY_EVENT_TYPES.TASKS,
  CALENDAR_API_QUERY_EVENT_TYPES.OUTLOOK,
] as const;

export const CALENDAR_API_PATHS = {
  FEED: '/api/calendar',
  TASK_DETAIL: (taskId: number | string) => `/api/event/task/${taskId}`,
  OUTLOOK_SYNC: '/api/calendar/outlook/sync',
} as const;
